module.exports = __webpack_public_path__ + "static/media/team--kevin.72705639.jpg";